// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"58ccdb07","455":"3d770d4b"}[chunkId] + ".chunk.js";
};